import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.regexp.replace";
import { MDXProvider } from '@mdx-js/react'; // eslint-disable-next-line import/no-extraneous-dependencies

import { Location } from '@reach/router';
import React from 'react';
import DocumentOutlineProvider from './components/DocumentOutlineProvider';
import InlineCode from './components/InlineCode';
import LinkedHeading from './components/LinkedHeading';
import List from './components/List';
import Heading from './components/OutlineHeading';
import Paragraph from './components/Paragraph';
import Pre from './components/Pre';
import DataProvider from './components/DataProvider';
import Anchor from './components/Anchor';

var stripTrailing = function stripTrailing(path) {
  return path === '/' ? '/' : path.replace(/\/$/, '');
};

export var components = {
  wrapper: function wrapper(props) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
  },
  a: Anchor,
  h1: function h1(props) {
    return /*#__PURE__*/React.createElement(Heading, Object.assign({
      h: "1"
    }, props));
  },
  h2: function h2(props) {
    return /*#__PURE__*/React.createElement(LinkedHeading, Object.assign({
      h: "2"
    }, props));
  },
  h3: function h3(props) {
    return /*#__PURE__*/React.createElement(LinkedHeading, Object.assign({
      h: "3"
    }, props));
  },
  h4: function h4(props) {
    return /*#__PURE__*/React.createElement(LinkedHeading, Object.assign({
      h: "4"
    }, props));
  },
  h5: function h5(props) {
    return /*#__PURE__*/React.createElement(LinkedHeading, Object.assign({
      h: "5"
    }, props));
  },
  h6: function h6(props) {
    return /*#__PURE__*/React.createElement(LinkedHeading, Object.assign({
      h: "6"
    }, props));
  },
  ul: function ul(props) {
    return /*#__PURE__*/React.createElement(List, props);
  },
  pre: function pre(props) {
    return /*#__PURE__*/React.createElement(Location, null, function (ctx) {
      var _props$children;

      return /*#__PURE__*/React.createElement(Pre, Object.assign({}, props, {
        name: stripTrailing(ctx.location.pathname),
        static: ((_props$children = props.children) === null || _props$children === void 0 ? void 0 : _props$children.props.live) !== true
      }));
    });
  },
  p: Paragraph,
  inlineCode: InlineCode
};
export default (function (_ref) {
  var element = _ref.element;
  return /*#__PURE__*/React.createElement(DataProvider, null, /*#__PURE__*/React.createElement(DocumentOutlineProvider, null, /*#__PURE__*/React.createElement(MDXProvider, {
    components: components
  }, element)));
});